// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../breakpoints.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/icons/pdf.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/icons/excel.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/assets/icons/delete.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/assets/icons/restore.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_col__hqTW7 {
    --width: 226px;
    text-align: left;
    width: var(--width);
    /*display: flex;*/
    /*flex-direction: column;*/

    /*display: grid;*/
    /*grid-row: span 7 / -1;*/
    /*grid-template-rows: subgrid;*/
    grid-gap: 0;
}

.styles_link__bl4Qt {
    width: var(--width);
    flex: 1 1;
    /*display: flex;*/
    /*flex-direction: column;*/

    /*display: grid;*/
    /*grid-row: span 6 / -1;*/
    /*grid-template-rows: subgrid;*/
    grid-gap: 0;
}

.styles_imgWrapper__aivUz {
    text-align: center;
    border: 1px solid #7b848e;
    padding: 14px 7px;
    color: var(--primary-color);
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
    height: calc(var(--width) - 40px);
    position: relative;
}

.styles_mainImg__q9KoE {
    width: 60%;
    height: auto;
    display: block;
    margin: auto;
}

.styles_secondaryImg__cT5Ex {
    position: absolute;
    width: 46px;
    right: 10px;
    top: 10px;
    max-width: 20%;
}

.styles_choice__muE5- {
    /*display: flex;*/
    flex-direction: column;
    justify-content: space-between;
    flex: 1 1;

    /*display: grid;*/
    /*grid-row: span 5 / -1;*/
    /*grid-row: span 5;*/
    /*grid-template-rows: subgrid;*/
}

.styles_choice__muE5-.styles_expanded__fyblg {
    grid-row: span 5 / -1;
}

.styles_choice__muE5- p {
    font-size: 13px;
    margin: 2px 0;
}

.styles_actions__tO3lV {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 9px;
    grid-gap: 8px;
}

.styles_actions__tO3lV button {
    --size: 20px;
    border: 0;
    background: transparent no-repeat center;
    background-size: auto 80%;
    padding: 0;
    width: var(--size);
    height: var(--size);
    position: relative;
}

.styles_actions__tO3lV button.styles_pdf__YyMcD {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.styles_actions__tO3lV button.styles_excel__IDM5- {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.styles_actions__tO3lV button.styles_delete__ggfks {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.styles_actions__tO3lV button.styles_restore__8\\+kO7 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.styles_tipBox__VlQ1o {
    position: absolute;
    width: 130px;
    background: #7b848e;
    padding: 10px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    color: #fff;
    font-size: 14px;
    line-height: 18px;
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);
    bottom: 26px;
    opacity: 0;
    transition: opacity 0.4s;
    pointer-events: none;
    max-height: 200px;
    overflow: auto;
    z-index: -1;
    text-align: center;
    border-radius: 3px;
}

.styles_actions__tO3lV button:hover .styles_tipBox__VlQ1o {
    opacity: 1;
    pointer-events: all;
    z-index: 99;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .styles_choice__muE5- p {
        font-size: 12px;
    }

    .styles_col__hqTW7 {
        --width: 180px;
    }

    .styles_imgWrapper__aivUz {
        margin-bottom: 10px;
        height: 150px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Preset/styles.module.css"],"names":[],"mappings":"AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,0BAA0B;;IAE1B,iBAAiB;IACjB,yBAAyB;IACzB,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,SAAO;IACP,iBAAiB;IACjB,0BAA0B;;IAE1B,iBAAiB;IACjB,yBAAyB;IACzB,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,8BAA8B;IAC9B,SAAO;;IAEP,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;IACpB,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,wCAAwC;IACxC,yBAAyB;IACzB,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yDAAkD;AACtD;;AAEA;IACI,yDAAoD;AACxD;;AAEA;IACI,yDAAqD;AACzD;;AAEA;IACI,yDAAsD;AAC1D;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,UAAU;IACV,wBAAwB;IACxB,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,aAAa;IACjB;AACJ","sourcesContent":["@value screen-md-max from '../../breakpoints.css';\n\n.col {\n    --width: 226px;\n    text-align: left;\n    width: var(--width);\n    /*display: flex;*/\n    /*flex-direction: column;*/\n\n    /*display: grid;*/\n    /*grid-row: span 7 / -1;*/\n    /*grid-template-rows: subgrid;*/\n    grid-gap: 0;\n}\n\n.link {\n    width: var(--width);\n    flex: 1;\n    /*display: flex;*/\n    /*flex-direction: column;*/\n\n    /*display: grid;*/\n    /*grid-row: span 6 / -1;*/\n    /*grid-template-rows: subgrid;*/\n    grid-gap: 0;\n}\n\n.imgWrapper {\n    text-align: center;\n    border: 1px solid #7b848e;\n    padding: 14px 7px;\n    color: var(--primary-color);\n    margin-bottom: 15px;\n    display: flex;\n    flex-direction: column;\n    height: calc(var(--width) - 40px);\n    position: relative;\n}\n\n.mainImg {\n    width: 60%;\n    height: auto;\n    display: block;\n    margin: auto;\n}\n\n.secondaryImg {\n    position: absolute;\n    width: 46px;\n    right: 10px;\n    top: 10px;\n    max-width: 20%;\n}\n\n.choice {\n    /*display: flex;*/\n    flex-direction: column;\n    justify-content: space-between;\n    flex: 1;\n\n    /*display: grid;*/\n    /*grid-row: span 5 / -1;*/\n    /*grid-row: span 5;*/\n    /*grid-template-rows: subgrid;*/\n}\n\n.choice.expanded {\n    grid-row: span 5 / -1;\n}\n\n.choice p {\n    font-size: 13px;\n    margin: 2px 0;\n}\n\n.actions {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    margin-bottom: 9px;\n    grid-gap: 8px;\n}\n\n.actions button {\n    --size: 20px;\n    border: 0;\n    background: transparent no-repeat center;\n    background-size: auto 80%;\n    padding: 0;\n    width: var(--size);\n    height: var(--size);\n    position: relative;\n}\n\n.actions button.pdf {\n    background-image: url('/src/assets/icons/pdf.svg');\n}\n\n.actions button.excel {\n    background-image: url('/src/assets/icons/excel.svg');\n}\n\n.actions button.delete {\n    background-image: url('/src/assets/icons/delete.svg');\n}\n\n.actions button.restore {\n    background-image: url('/src/assets/icons/restore.svg');\n}\n\n.tipBox {\n    position: absolute;\n    width: 130px;\n    background: #7b848e;\n    padding: 10px;\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);\n    color: #fff;\n    font-size: 14px;\n    line-height: 18px;\n    margin: 0 auto;\n    left: 50%;\n    transform: translateX(-50%);\n    bottom: 26px;\n    opacity: 0;\n    transition: opacity 0.4s;\n    pointer-events: none;\n    max-height: 200px;\n    overflow: auto;\n    z-index: -1;\n    text-align: center;\n    border-radius: 3px;\n}\n\n.actions button:hover .tipBox {\n    opacity: 1;\n    pointer-events: all;\n    z-index: 99;\n}\n\n@media screen-md-max {\n    .choice p {\n        font-size: 12px;\n    }\n\n    .col {\n        --width: 180px;\n    }\n\n    .imgWrapper {\n        margin-bottom: 10px;\n        height: 150px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"col": `styles_col__hqTW7`,
	"link": `styles_link__bl4Qt`,
	"imgWrapper": `styles_imgWrapper__aivUz`,
	"mainImg": `styles_mainImg__q9KoE`,
	"secondaryImg": `styles_secondaryImg__cT5Ex`,
	"choice": `styles_choice__muE5-`,
	"expanded": `styles_expanded__fyblg`,
	"actions": `styles_actions__tO3lV`,
	"pdf": `styles_pdf__YyMcD`,
	"excel": `styles_excel__IDM5-`,
	"delete": `styles_delete__ggfks`,
	"restore": `styles_restore__8+kO7`,
	"tipBox": `styles_tipBox__VlQ1o`
};
export default ___CSS_LOADER_EXPORT___;
